@if (horizontalMenu) {
  <div class="navbar-header d-xl-block d-none">
    <!-- Navbar brand -->
    <ul class="nav navbar-nav flex-row">
      <li class="nav-item">
        <a
          class="navbar-brand"
          [routerLink]="['/']">
          <span class="brand-logo">
            <img
              [src]="logoService.logoPath"
              alt="brand-logo" />
          </span>
        </a>
      </li>
    </ul>
    <!--/ Navbar brand -->
  </div>
}

<div class="navbar-container d-flex content justify-content-between">
  <div class="bookmark-wrapper d-flex align-items-center">
    <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
    @if (!coreConfig.layout.menu.hidden) {
      <ul class="nav navbar-nav d-xl-none">
        <li class="nav-item">
          <a
            class="nav-link menu-toggle"
            (click)="toggleSidebar('menu')">
            <span
              [data-feather]="'menu'"
              [class]="'ficon'"></span>
          </a>
        </li>
      </ul>
    }
    <!--/ Menu Toggler -->

    <!-- Toggle skin -->
    <ul class="nav navbar-nav">
      <li class="nav-item d-block">
        <button
          (click)="toggleDarkSkin()"
          class="nav-link nav-link-style btn">
          <span
            [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'"
            class="ficon font-medium-5 feather"></span>
        </button>
      </li>
    </ul>
    <!--/ Toggle skin -->
  </div>

  <ul class="nav navbar-nav align-items-center">
    <!-- ? Language selection | Uncomment if needed-->
    <!-- <li ngbDropdown class="nav-item dropdown dropdown-language">
    <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
      <i class="flag-icon flag-icon-{{ languageOptions[_translateService.currentLang].flag }}"></i
        ><span class="selected-language">{{ languageOptions[_translateService.currentLang].title }}</span></a
        >
        <div ngbDropdownMenu aria-labelledby="dropdown-flag">
          <a *ngFor="let lang of _translateService.getLangs()" ngbDropdownItem (click)="setLanguage(lang)">
            <i class="flag-icon flag-icon-{{ languageOptions[lang].flag }}"></i> {{ languageOptions[lang].title }}
          </a>
        </div>
      </li> -->
    <!--/ Language selection -->

    <!-- User Dropdown -->
    <li
      class="nav-item dropdown-user"
      ngbDropdown>
      <a
        aria-expanded="false"
        aria-haspopup="true"
        class="nav-link dropdown-toggle dropdown-user-link"
        id="navbarUserDropdown"
        ngbDropdownToggle>
        <div class="user-nav d-sm-flex d-none">
          <span class="user-name fw-bolder">{{ currentUser?.email }}</span>
          <span class="user-status">
            @for (office of currentUser?.offices; track office.id; let last = $last) {
              {{ office.name + (last ? "" : ", ") }}
            }
          </span>
        </div>
        <span class="avatar">
          <svg
            class="bi bi-person-circle text-primary"
            fill="currentColor"
            height="40"
            viewBox="0 0 16 16"
            width="40"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
            <path
              d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
              fill-rule="evenodd" />
          </svg>
        </span>
      </a>
      <div
        aria-labelledby="navbarUserDropdown"
        class="dropdown-menu dropdown-menu-right"
        ngbDropdownMenu>
        @if (_authenticationService.vertretenByString) {
          <a ngbDropdownItem (click)="returnToMainUser()"
          ><span data-feather="log-out" [class]="'me-50'"></span> {{ _authenticationService.vertretenByString }}</a
          >
        } @else {
          <a
            (click)="openUserModal()"
            ngbDropdownItem
            ><span
              [class]="'me-50'"
              data-feather="user"></span>
            {{ "NAV.USER" | translate }}</a
          >
        }
        <div class="dropdown-divider"></div>
        <a
          (click)="logout()"
          ngbDropdownItem
          ><span
            [class]="'me-50'"
            data-feather="power"></span>
          {{ "NAV.LOGOUT" | translate }}</a
        >
      </div>
    </li>
    <!--/ User Dropdown -->
  </ul>
</div>
